import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

type Option = { label: string; value: any };

@Component({
  selector: 'app-filter-bar',
  templateUrl: './filter-bar.component.html',
  styleUrls: ['./filter-bar.component.scss'],
  standalone: false
})
export class FilterBarComponent {
  @Input() placeholder = 'Buscar';
  @Input() dropdownOptions: Option[] = [];
  @Input() dropdownValue: any;
  @Input() dropdownLabel = '';
  @Input() dropdown2Options: Option[] = [];
  @Input() dropdown2Value: any;
  @Input() dropdown2Label = '';
  @Input() textSearch = '';

  @Output() searchChange = new EventEmitter<string>();
  @Output() dropdownChange = new EventEmitter<any>();
  @Output() dropdown2Change = new EventEmitter<any>();
  @Output() textSearchChange = new EventEmitter<string>();

  isOpen = false;
  isOpen2 = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  get currentLabel(): string {
    const found = this.dropdownOptions.find(o => o.value === this.dropdownValue);
    return found ? found.label : (this.dropdownOptions[0]?.label ?? '');
  }

  get currentLabel2(): string {
    const found = this.dropdown2Options.find(o => o.value === this.dropdown2Value);
    return found ? found.label : (this.dropdown2Options[0]?.label ?? '');
  }

  onInput(v: string) {
    this.textSearch = v;
  }

  onSearchClick() {
    const value = this.textSearch.trim();
    this.textSearch = value;
    this.textSearchChange.emit(value);
    this.searchChange.emit(value);
  }

  toggle() { this.isOpen = !this.isOpen; this.isOpen2 = false; }
  toggle2() { this.isOpen2 = !this.isOpen2; this.isOpen = false; }

  select(opt: Option) {
    this.dropdownValue = opt.value;
    this.dropdownChange.emit(opt.value);
    this.isOpen = false;
  }

  select2(opt: Option) {
    this.dropdown2Value = opt.value;
    this.dropdown2Change.emit(opt.value);
    this.isOpen2 = false;
  }

  @HostListener('document:click', ['$event'])
  onDocClick(e: MouseEvent) {
    if (!this.host.nativeElement.contains(e.target as Node)) {
      this.isOpen = false;
      this.isOpen2 = false;
    }
  }
}
